import L from "leaflet";
import type { ParcelDTO } from "../../api";

export const ITALY_CENTER: [number, number] = [42.5, 12.5];

export function configureLeafletIcon(): void {
  L.Icon.Default.mergeOptions({
    iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    iconRetinaUrl:
      "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  });
}

export function readCssToken(name: string, fallbackName?: string): string {
  const styles = getComputedStyle(document.documentElement);
  let current = name;
  const seen = new Set<string>();

  for (let i = 0; i < 4; i += 1) {
    const raw = styles.getPropertyValue(current).trim();
    const nested = /^var\((--[\w-]+)(?:,\s*([^)]+))?\)$/.exec(raw);
    if (!nested) {
      return raw || (fallbackName ? styles.getPropertyValue(fallbackName).trim() : "");
    }
    if (seen.has(nested[1])) break;
    seen.add(nested[1]);
    current = nested[1];
  }

  return fallbackName ? styles.getPropertyValue(fallbackName).trim() : "";
}

export function drawParcelLayer(map: L.Map, parcels: ParcelDTO[]): L.LayerGroup {
  const primaryColor = readCssToken("--map-parcel-primary", "--danger");
  const secondaryColor = readCssToken("--map-parcel-secondary", "--warn");
  const group = L.layerGroup().addTo(map);

  parcels.forEach((parcel, idx) => {
    if (!parcel.polygon_latlon || parcel.polygon_latlon.length < 3) return;
    const coords: L.LatLngExpression[] = parcel.polygon_latlon.map(
      ([lat, lon]) => [lat, lon] as [number, number],
    );
    const isPrimary = idx === 0;
    const color = isPrimary ? primaryColor : secondaryColor;
    const poly = L.polygon(coords, {
      color,
      weight: isPrimary ? 2.5 : 1.5,
      fillColor: color,
      fillOpacity: isPrimary ? 0.18 : 0.08,
    });
    poly.bindTooltip(
      `<strong>${parcel.nat_ref}</strong><br/>foglio ${parcel.foglio} · particella ${parcel.particella}`,
      { sticky: true },
    );
    poly.addTo(group);
  });

  return group;
}
